<template>
    <div class="single-product__size-guide custom_earring" data-index="1">
        <div class="single-product__size-guide-container">
            <a class="single-product__size-guide--btn" @click="show_guide__popup">Earring Size Guide</a><img alt="alert-info" src="/single-product/alert-info-icon.webp">
        </div>
        <div class="size-guide__popup" ref="popupRef" id="size-guide__popup-1" :class="open ? 'active' : ''">
            <div class="size-guide__content"  ref="contentRef">
                <h4 class="size-guide__heading">Earring Size Guide</h4>
                <div class="size-guide__tab-panel">
                    <span data-tab="size-chart" class="size-guide__tab size-guide__tab--size-chart active">DIAMOND STUDS</span>
                    <span data-tab="guide" class="size-guide__tab size-guide__tab--guide">HOOP EARRINGS</span>
                    <span data-tab="dangle" class="size-guide__tab size-guide__tab--dangle">DANGLE EARRINGS</span>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart active">
                    <div class="ear_diamond">
                        <div class="content_tab1 custom_short">
                            This guide is for solitaire diamond studs only. Cluster diamond earrings are made up of loose diamonds of various carat sizes. Hence, to determine the dimension, you may use the centre solitaire diamond as a guide.
                        </div>
                        <div class="content_tab1 tab1_op">
                            <div class="img_title">
                                <img src="/single-product/img1.webp" class="size-guide__image" alt="ring-size-guide-img">
                                <h5>Solitaire</h5>
                                <p>1 Single Diamond</p>
                            </div>
                            <div class="img_title">
                                <img src="/single-product/img2.webp" class="size-guide__image" alt="ring-size-guide-img">
                                <h5>Cluster</h5>
                                <p>Multiple Loose Diamonds</p>
                            </div>
                        </div>
                        <div class="detail-size">
                            <h4>DETERMINE YOUR LOBE SIZE</h4>
                            <img src="/single-product/detail_size.webp" class="size-guide__image" alt="ring-size-guide-img">
                        </div>
                        <div class="detail-size footer_tab1">
                            <h4>THINGS TO NOTE</h4>
                            <div class="check_op_tab">
                                <div class="number">1</div>
                                <div class="content_number">Measured by carat weight and not size in cm/mm.</div>
                            </div>
                            <div class="check_op_tab">
                                <div class="number">2</div>
                                <div class="content_number">Carat size indicated is per pair, not per stud unless otherwise noted.</div>
                            </div>
                            <div class="check_op_tab">
                                <div class="number">3</div>
                                <div class="content_number">Hence, divide total carat size by 2 to get the carat size per stud for measurement.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--guide pt_guide">
                    <div class="ring-size__tab-panel">
                        <span data-tab="find-ring-size" class="ring-size__tab active">Size Chart</span>
                        <span data-tab="free-size-ring" class="ring-size__tab">Measurement Guide</span>
                    </div>
                    <div class="ring-size__tab-content ring-size__tab-content--find-ring-size alt-ring-size active">
                        <h4>HOW IS IT MEASURED?</h4>
                        <img src="/single-product/size_ring.webp" class="size-guide__image custom_img pt_custom" alt="ring-size-guide-img">
                        <div class="ring-size__tab-content ring-size__tab-content--find-ring-size sub_content active pt_custom">Hoop earrings are typically measured by their diameter in millimeters (mm). Fit will also depend on individual’s lobe size and which piercing you will be wearing the earrings on.</div>
                        <div class="ring-size__tab-content ring-size__tab-content--find-ring-size active pt_custom" style="margin-bottom: 0px;">
                            <h4>MEASUREMENTS</h4>
                            <div class="custom_hoop_earrings">
                                <div class="cs_size_guide">
                                    <div class="size-guide__tab-content size-guide__tab-content--size-chart active">
                                        <div class="size-guide__size-chart">
                                            <table>
                                                <tbody>
                                                    <tr v-for="(row, rowIndex) in sizeEarrings" :key="rowIndex">
                                                        <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                                                        {{ cell }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="img_cs_size">
                                    <img src="/single-product/size_op_ring.webp" class="size-guide__image" alt="ring-size-guide-img">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ring-size__tab-content ring-size__tab-content--free-size-ring alt-ring-size">
                        <h4>HOW TO MEASURE?</h4>
                        <div class="size-guide__method-title"><span>Method 1: </span><span> By Ruler</span></div>
                        <img src="/single-product/size_op_ring2.webp" data-original_src="/single-product/ring-size-free-1.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>Take a cm/mm ruler and measure from the piercing to the bottom of your lobe.</span>
                        </div>
                        <img src="/single-product/rule_ring.webp" style="margin-top: 15px" data-original_src="/single-product/ring-size-free-2.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span>Compare the length to the hoop earring length, measure across the largest the cross-section of the circle.</span>
                        </div>
                        <p class="sub_bold_title">*For more space between your ear and huggie, add 1-2mm to your measured length.</p>
                        <div class="size-guide__method-title"><span>Method 2: </span><span> By Reference</span></div>
                        <p class="pt_content">However, if you do not have a ruler with you, use the following chart to find out which ear size best describes yours to determine the ideal fit.</p>
                        <img src="/single-product/detail_size_2.webp" class="size-guide__image custom_img_size" alt="ring-size-guide-img">
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--dangle pt_dangle">
                    <div class="ring-size__tab-panel">
                        <span data-tab="find-dangle-size" class="ring-size__tab active guide_tab">Size Chart</span>
                        <span data-tab="free-dangle-ring" class="ring-size__tab guide_tab">Measurement Guide</span>
                    </div>
                    <div class="ring-size__tab-content ring-size__tab-content--find-dangle-size active custom_guide">
                        <div class="ring-size__tab-content ring-size__tab-content--find-dangle-size sub_content active pt_custom cs_dangle" >In general, your comfortable length may be around 4-6cm (1.5"-2.3"). 
                            <span>A drop pendant earring of 7-9cm (2.5"-3.5") may reach just below your jaw line or half-way down your neck.</span> </div>
                        <div class="ring-size__tab-content ring-size__tab-content--find-dangle-size active pt_custom" style="margin-bottom: 0px;">
                            <div class="custom_hoop_earrings">
                                <div class="cs_size_guide">
                                    <div class="size-guide__tab-content size-guide__tab-content--size-chart active">
                                        <div class="size-guide__size-chart">
                                            <table>
                                                <tbody>
                                                    <tr v-for="(row, rowIndex) in sizeDropEarrings" :key="rowIndex">
                                                        <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                                                        {{ cell }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="img_cs_size">
                                    <img src="/single-product/rule_ring2.png" style="width: 80%;" class="size-guide__image" alt="ring-size-guide-img">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ring-size__tab-content ring-size__tab-content--free-dangle-ring">
                        <h4>HOW TO MEASURE?</h4>
                        <div class="ring-size__tab-content ring-size__tab-content--find-dangle-size sub_content active pt_custom cs_dangle" >Lengths start from your piercing and can go up to 18-20cm.</div>
                        <div class="ring-size__tab-content ring-size__tab-content--find-dangle-size sub_content active pt_custom cs_dangle" >The best way to know what size is best for you is to measure, using a ruler, from your piercing to your preferred length.</div>

                        <img src="/single-product/size_op_ring2_1.webp" data-original_src="/single-product/ring-size-free-1.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>Take a cm/mm ruler and measure from the piercing to the bottom of your lobe.</span>
                        </div>
                        <img src="/single-product/rule_ring_3.webp" style="margin-top: 15px;" data-original_src="/single-product/ring-size-free-2.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span>Compare the length to the dangle earring length, measure from the stud.</span>
                        </div>
                    </div>
                </div>
                <div class="size-guide__footer">
                    <a @click="close_guide__popup" class="size-guide__close"><span>Continue Shopping</span></a>
                </div>
                <span class="size-guide__close-btn" @click="close_guide__popup">
                    <svg class="icon_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_sizeguide.scss";
</style>

<script setup lang="ts">
    const { $ajax, $file } = useNuxtApp();
    const userStore = useUserStore();
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const sizeEarrings = ref([
        ['Diameter (MM)', 'Description'],
        ["<10mm", "Huggies"],
        ["10-15mm", "Small Hoops"],
        ["15-20mm", "Medium Hoops"],
        ["20-25mm", "Large Hoops"],
        [">25mm", "Extra Large Hoops"],
    ]);
    const sizeDropEarrings = ref([
        ['Drop Length (CM)', 'Fit Guide'],
        ["0-2cm", "Slight drop"],
        ["2-4cm", "Above jawline"],
        ["4-6cm", "Touching jawline"],
        ["7-8cm", "Below jawline"]
    ]);
    const file_link=ref()
    const getFile = async () => {
        try {
            const response = await $ajax.get('wp-json/skj/v1/download-size-chart');

            console.log(response)
            if(response) {
                file_link.value = response.download_url
            }
        } catch (error) {
            console.log('Failed. Retrying...');
        }

    }
    getFile();
    const open = ref(false)
    const show_guide__popup = () =>{
        open.value = true,
        document.body.style.overflowY = 'hidden';
        setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
        }, 500);
    }
    const close_guide__popup = () =>{
        open.value = false,
        document.body.style.overflowY = 'scroll';
        document.removeEventListener('click', handleClickOutside);
    }
    const popupRef = ref<HTMLElement | null>(null);
    const contentRef = ref<HTMLElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (contentRef.value && !contentRef.value.contains(event.target as Node)) {
            close_guide__popup();
        }
    };

    const popupSwitchMeasurementTab = () => {
        const tabsPanel = document.querySelectorAll<HTMLElement>(".size-guide__popup .pt_guide .ring-size__tab");
        if (tabsPanel.length > 0) {
            tabsPanel.forEach((tabPanel) => {
                tabPanel.addEventListener("click", (e: Event) => {
                    const modalPopup = tabPanel.closest(".size-guide__popup") as HTMLElement | null;

                    // Ensure modalPopup is not null
                    if (!modalPopup) return;

                    // Hide all tab content
                    const tabContent = modalPopup.querySelectorAll<HTMLElement>(".pt_guide .ring-size__tab-content");
                    tabContent.forEach((content) => content.classList.remove("active"));

                    // Remove active class from all tabs
                    const tabLinks = modalPopup.querySelectorAll<HTMLElement>(".pt_guide .ring-size__tab");
                    tabLinks.forEach((link) => link.classList.remove("active"));

                    const tab = tabPanel.getAttribute("data-tab");
                    if (tab) {
                        tabPanel.classList.add("active");
                        const tabName = `.pt_guide .ring-size__tab-content--${tab}`;
                        const _tabContent = modalPopup.querySelector<HTMLElement>(tabName);

                        if (_tabContent) {
                            _tabContent.classList.add("active");
                        }

                        const contentFooter = modalPopup.querySelector<HTMLElement>(".size-guide__content-footer");

                        if (contentFooter) {
                            if (tab === "find-ring-size" ) {
                                contentFooter.style.display = "flex";
                            } else {
                                contentFooter.style.display = "none";
                            }
                        }
                    }
                });
            });
        }
        const tabsPanel_guide = document.querySelectorAll<HTMLElement>(".size-guide__popup .pt_dangle .ring-size__tab");
        if (tabsPanel_guide.length > 0) {
            tabsPanel_guide.forEach((tabPanel) => {
                tabPanel.addEventListener("click", (e: Event) => {
                    const modalPopup = tabPanel.closest(".size-guide__popup") as HTMLElement | null;

                    // Ensure modalPopup is not null
                    if (!modalPopup) return;

                    // Hide all tab content
                    const tabContent = modalPopup.querySelectorAll<HTMLElement>(".pt_dangle .ring-size__tab-content");
                    tabContent.forEach((content) => content.classList.remove("active"));

                    // Remove active class from all tabs
                    const tabLinks = modalPopup.querySelectorAll<HTMLElement>(".pt_dangle .ring-size__tab");
                    tabLinks.forEach((link) => link.classList.remove("active"));

                    const tab = tabPanel.getAttribute("data-tab");
                    if (tab) {
                        tabPanel.classList.add("active");
                        const tabName = `.pt_dangle .ring-size__tab-content--${tab}`;
                        const _tabContent = modalPopup.querySelector<HTMLElement>(tabName);

                        if (_tabContent) {
                            _tabContent.classList.add("active");
                        }

                        const contentFooter = modalPopup.querySelector<HTMLElement>(".size-guide__content-footer");

                        if (contentFooter) {
                            if (tab === "find-dangle-size") {
                                contentFooter.style.display = "flex";
                            } else {
                                contentFooter.style.display = "none";
                            }
                        }
                    }
                });
            });
        }
    };

    onMounted(() => {
        getFile();
        popupSwitchMeasurementTab()
        const sizeguideTabs = document.querySelectorAll<HTMLDivElement>('#size-guide__popup-1 .size-guide__tab');
        if (sizeguideTabs.length > 0) {
            sizeguideTabs.forEach((tab: HTMLDivElement) => {
                tab.addEventListener('click', (e: Event) => {
                    e.preventDefault();
                    const target = e.currentTarget as HTMLDivElement; // Type assertion for `this`
                    const index = target.getAttribute('data-tab'); // `index` can be `null`, so handle it accordingly
                    if (index !== null) {
                        changeTab(index);
                    }
                });
            });
        }
    })
    const changeTab = (index: any) => {
        const tabContents = document.querySelectorAll('#size-guide__popup-1 .size-guide__tab-content');
        const sizeguideTabs = document.querySelectorAll('#size-guide__popup-1 .size-guide__tab');

        tabContents.forEach(function(tabContent) {
            tabContent.classList.remove('active');
        });

        sizeguideTabs.forEach(function(sizeguideTab) {
            sizeguideTab.classList.remove('active');
        });

        const selectedTabContent = document.querySelector('#size-guide__popup-1 .size-guide__tab--' + index + '');
        const selectedSizeGuideTab = document.querySelector('#size-guide__popup-1 .size-guide__tab-content--' + index + '');
        if (selectedTabContent && selectedSizeGuideTab) {
            selectedTabContent.classList.add('active');
            selectedSizeGuideTab.classList.add('active');
        }
    }
</script>